export default Object.freeze({
  NEUTRAL: 'neutral',
  HIGHLIGHT: 'highlight',
  SUCCESS: 'success',
  WARNING: 'warning',
  CRITICAL: 'critical',
});
